// extracted by mini-css-extract-plugin
export default {"title":"xJomvVUKrDFSE_TeAUJnc"};